/* eslint-disable react/prop-types */
import React from 'react';
import {
  Stack,
  VStack,
  HStack,
  Text,
  AvatarGroup,
  Avatar,
  Spacer,
  Tag,
  useColorMode,
} from '@chakra-ui/react';
import moment from 'moment';
import DynamicButton from '../Buttons/DynamicButton';
import { useTranslation } from 'react-i18next';

function CardAutomation({
  Icon,
  data,
  globalState,
  onNavigate,
  userArray,
  title,
  timeCreated,
  modalTeam,
  owner,
  onDelete,
  onEdit,
}) {
  const findProject = globalState?.projects?.find(
    (x) => x?.id === data?.projectId
  );

  const {t} = useTranslation()
  const { colorMode } = useColorMode();


  return (
    <Stack shadow="base" bgColor={colorMode === 'dark' ? 'gray.700' : 'white'}>
      <VStack align="flex-start" w="full" h="full" justify="space-between">
        <HStack spacing={3} px={4} pt={4} w="100%" position={'relative'}>
          {data.isActive === true ? (
            <Tag
              position={'absolute'}
              top={3}
              right={3}
              size="sm"
              colorScheme={'green'}
            >
              {t('active')}
            </Tag>
          ) : (
            <Tag
              position={'absolute'}
              top={3}
              right={3}
              size="sm"
              colorScheme={'red'}
            >
              {t('nonActive')}
            </Tag>
          )}
          <Stack cursor="pointer" onClick={onNavigate}>
            {Icon && <Icon size={50} />}
          </Stack>
          <Stack spacing={1}>
            <Text
              textTransform="capitalize"
              cursor="pointer"
              noOfLines={1}
              fontSize="sm"
              fontWeight="medium"
              onClick={onNavigate}
            >
              {title}
            </Text>
            <Text
              textTransform="capitalize"
              cursor="pointer"
              noOfLines={1}
              fontSize="xs"
              onClick={onNavigate}
            >
              {t('from')} : {data?.dataAutomation?.title}
            </Text>
            <Text
              textTransform="capitalize"
              cursor="pointer"
              noOfLines={1}
              fontSize="xs"
              onClick={onNavigate}
            >
              {t('action')} : {data.action}
            </Text>
            <Text
              textTransform="capitalize"
              cursor="pointer"
              noOfLines={1}
              fontSize="xs"
              onClick={onNavigate}
            >
              {t('to2')} : {data.fileTo}
            </Text>
            {userArray?.length > 0 && (
              <AvatarGroup
                onClick={modalTeam}
                cursor="pointer"
                size="sm"
                max={5}
              >
                {userArray?.map((user, i) => (
                  <Avatar key={i} name={user.name} />
                ))}
              </AvatarGroup>
            )}
          </Stack>
        </HStack>

        <HStack
          alignItems="center"
          justifyContent="space-around"
          w="full"
          p={3}
          mt={3}
        >
          <Stack spacing={0}>
            <Text spacing={3} fontSize="2xs">
              {t('project')}: {findProject?.name}
            </Text>
            <HStack>
              <Text spacing={3} fontSize="2xs">
                {t('lastActivity')} {`${moment.unix(timeCreated).fromNow()}`}
              </Text>
            </HStack>
          </Stack>
          <Spacer />
          {owner?.includes(globalState?.uid) && (
            <HStack spacing={2}>
              {onEdit && (
                <DynamicButton action={'update'} size="sm" onClick={onEdit} />
              )}

              {onDelete && (
                <DynamicButton action={'delete'} size="sm" onClick={onDelete} />
              )}
            </HStack>
          )}
        </HStack>
      </VStack>
    </Stack>
  );
}

export default CardAutomation;
